import React from 'react';

const icon = () => (
  <span className="svg-icon v-centered svg-icon--42">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
      <rect width="40" height="40" fill="none" />
      <g>
        <path d="M32.5,20A12.5,12.5,0,1,1,20,7.5,12.4578,12.4578,0,0,1,32.5,20Z" fill="none" stroke="#B1B9BF" strokeMiterlimit="10" />
        <line x1="28.8045" y1="11.1955" x2="11.1868" y2="28.8132" fill="none" stroke="#B1B9BF" strokeMiterlimit="10" />
      </g>
    </svg>
  </span>
);

export default icon;
